import deepmerge from "deepmerge";

// Obtener oferta
const oferta = require(`./${process.env.VUE_APP_CAMP}.js`).default;
const ofertaDigital = require(`./ofertaDigital.js`).default;

export default deepmerge(ofertaDigital, oferta);
